/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerFeeType;

(function (BrokerFeeType) {
  BrokerFeeType["MONETARY"] = "monetary";
  BrokerFeeType["PERCENTAGE"] = "percentage";
})(BrokerFeeType || (BrokerFeeType = {}));